import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function DCCFlyer({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({});
  

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setPrimaryDetails((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (isError[name]) {
      setIsError((prev) => ({
        ...prev,
        [name]: false,
      }));
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!primaryDetails.dcc_installed) {
      errors.dcc_installed = true;
    }
    setIsError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleNext = (e) => {
  if (e && e.preventDefault) e.preventDefault();
  if (!validateForm()) {
    toast.error("Please select Yes or No.");
    return;
  }
  if (primaryDetails.dcc_installed === "Yes") {
    navigation.go("dcc-flyer-photo");
  } else {
    navigation.go("maya-kita-club-flyer");
  }
};


  const handleBack = (e) => {
    navigation.previous();
  };

  const options = ["Yes", "No"];

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">DCC FLYER</h4>
              <p className="form-desc">Nag-install ka ba ng DCC flyer?</p>
            </div>

            <div className="form-main">
              <div className="form-main-content">
                <Form className="form-form">
                  {/* DCC Flyer Installation */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Nag-install ka ba ng DCC flyer?
                      <span className="form-required">*</span>
                    </Form.Label>
                    <div
                      className={`form-radio-group ${
                        isError.dcc_installed ? "form-group-error" : ""
                      }`}
                    >
                      {options.map((option) => (
                        <div key={option} className="form-radio-item">
                          <Form.Check
                            type="radio"
                            id={`dcc_flyer_${option.toLowerCase()}`}
                            name="dcc_installed"
                            value={option}
                            checked={
                              primaryDetails.dcc_installed === option
                            }
                            onChange={handleInputChange}
                            label={option}
                            className="form-radio"
                          />
                        </div>
                      ))}
                    </div>
                    {isError.dcc_installed && (
                      <div className="form-error">
                        Please select Yes or No.
                      </div>
                    )}
                  </Form.Group>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      type="button"
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      type="button"
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                    >
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Modal to preview backend response */}
      {/* <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Backend Response Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <pre>{JSON.stringify(backendResponse, null, 2)}</pre>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleModalClose}>
            Continue
          </Button>
        </Modal.Footer>
      </Modal> */}
    </div>
  );
}

export default DCCFlyer;
